import httpClient from "@/store/httpClient";

export default {
    namespaced: true,
    state: {
        updates: [],
        selectedUpdateId: null,
        showPortalUpdateDialog: false,
    },
    mutations: {
        SET_UPDATES(state, updates) {
            state.updates = updates;
        },
        SET_SELECTED_UPDATE_ID(state, updateId) {
            state.selectedUpdateId = updateId;
        },
        SET_SHOW_PORTAL_UPDATE_DIALOG(state, showPortalUpdateDialog) {
            state.showPortalUpdateDialog = showPortalUpdateDialog;
        }
    },
    actions: {
        async loadUpdates({ commit }) {
            const response = await httpClient("/portal-updates/for-user");
            if(response.status === 200) {
                commit("SET_UPDATES", response.data);
            }
        },
        async markAsRead({ dispatch }, id) {
            const response = await httpClient.put(`/portal-updates/read?id=${id}`);
            if(response.status === 200) {
                dispatch("loadUpdates");
            }
        },
        openUpdateDialog({ commit }, updateId) {
            commit("SET_SELECTED_UPDATE_ID", updateId);
            commit("SET_SHOW_PORTAL_UPDATE_DIALOG", true);
        },
        closeUpdateDialog({ commit }) {
            commit("SET_SHOW_PORTAL_UPDATE_DIALOG", false);
        }
    },
    getters: {
        getLatestUnreadUpdate: (state) => state.updates.find(u => !u.seen),
        getSelectedUpdate: (state, getters) => state.updates.find(u => u.id === state.selectedUpdateId) || getters.getLatestUnreadUpdate,
        getShowPortalUpdateDialog: (state) => state.showPortalUpdateDialog,
        getPortalUpdates: (state) => state.updates,
        getUnreadPortalUpdatesCount: (state) => state.updates.filter(u => !u.seen).length,
    }
}
